import React, {RefObject} from "react";
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {rankingLastYear} from "../../constants/ranking";

interface IProps {
    scrollRefElem: RefObject<HTMLDivElement | null>;
    centerLayout?: boolean;
    year?: string;
}

export function OfferRankingCreationSteps(props: IProps) {
    const {year, scrollRefElem, centerLayout} = props;

    return (
        <div className={cx(creationSteps, centerLayout && creationStepsCenterLayout)} ref={scrollRefElem}>
            <Text variant="headline_3" as="h2" align="center">
                Zobacz, jak powstał ranking
            </Text>

            <Text variant="body_copy_0" align="center" className={outro}>
                Ranking powstał na podstawie analizy odwiedzin stron inwestycji opublikowanych na {concatWithBrandName("")} w całym{" "}
                <b>{year ?? rankingLastYear} roku</b>. W sumie wyłoniliśmy <b>10 najpopularniejszych osiedli</b>, które cieszyły się największym
                zainteresowaniem naszych użytkowników.
                <br />
                Na tej podstawie stworzyliśmy finałowe zestawienie, w którym wskazaliśmy <b>3 laureatów</b> oraz przyznaliśmy <b>2 wyróżnienia</b> dla
                inwestycji w każdym z miast.
            </Text>
        </div>
    );
}

const creationSteps = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "1128px"
});

const creationStepsCenterLayout = css({
    width: "100%",
    marginInline: "auto",
    textAlign: "center",
    mb: 3
});

const outro = css({
    maxWidth: "552px"
});
import React, {RefObject} from "react";
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {rankingLastYear} from "../../constants/ranking";

interface IProps {
    scrollRefElem: RefObject<HTMLDivElement | null>;
    centerLayout?: boolean;
    year?: string;
}

export function OfferRankingCreationSteps(props: IProps) {
    const {year, scrollRefElem, centerLayout} = props;

    return (
        <div className={cx(creationSteps, centerLayout && creationStepsCenterLayout)} ref={scrollRefElem}>
            <Text variant="headline_3" as="h2" align="center">
                Zobacz, jak powstał ranking
            </Text>

            <Text variant="body_copy_0" align="center" className={outro}>
                Ranking powstał na podstawie analizy odwiedzin stron inwestycji opublikowanych na {concatWithBrandName("")} w całym{" "}
                <b>{year ?? rankingLastYear} roku</b>. W sumie wyłoniliśmy <b>10 najpopularniejszych osiedli</b>, które cieszyły się największym
                zainteresowaniem naszych użytkowników.
                <br />
                Na tej podstawie stworzyliśmy finałowe zestawienie, w którym wskazaliśmy <b>3 laureatów</b> oraz przyznaliśmy <b>2 wyróżnienia</b> dla
                inwestycji w każdym z miast.
            </Text>
        </div>
    );
}

const creationSteps = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "1128px"
});

const creationStepsCenterLayout = css({
    width: "100%",
    marginInline: "auto",
    textAlign: "center",
    mb: 3
});

const outro = css({
    maxWidth: "552px"
});
